module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [(_vm.isLoading) ? _c('relatorio-loading') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "content-transition relatorio-print",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "text-center m-t m-b-n"
  }, [_c('h3', {
    staticClass: "btn m-t-none",
    on: {
      "click": function($event) {
        _vm.showFiltros = !_vm.showFiltros
      }
    }
  }, [_c('span', {
    staticClass: "btn btn-default btn-xs m-r-xs"
  }, [_vm._v(_vm._s(!_vm.showFiltros ? '+' : '-'))]), _vm._v("Filtros\n          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "r-table"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, [_c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Data:")]), _vm._v("\n                Data Início: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.data1),
      expression: "filtro.data1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "input-sm",
    domProps: {
      "value": (_vm.filtro.data1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "data1", $event.target.value)
      }
    }
  }), _vm._v(" Data Fim: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.data2),
      expression: "filtro.data2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "input-sm",
    domProps: {
      "value": (_vm.filtro.data2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtro, "data2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Tipo de Pessoa:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.tiposPessoa
    },
    model: {
      value: (_vm.filtro.tipoPessoa),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipoPessoa", $$v)
      },
      expression: "filtro.tipoPessoa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Situação do Cadastro:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.situacaoCadastro
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-lg"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.geraRelatorio,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.geraRelatorio.apply(null, arguments)
      }
    }
  }, [_vm._v("Gerar Relatório\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("Relatório de Arrematantes")])]), _vm._v(" "), (_vm.result !== null) ? _c('div', [_c('div', {
    staticClass: "printer-page pos-rlt"
  }, [_c('div', {
    staticClass: "r-table"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, [_c('table', {
    staticClass: "table table-bordered r-table-min"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Período:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data1) + " a " + _vm._s(_vm.data2))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total de cadastros")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.result.resumo.total))]), _vm._v(" (" + _vm._s(_vm.result.resumo.totalPF) + " PF /\n                    " + _vm._s(_vm.result.resumo.totalPJ) + " PJ)\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cadastros Completos:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.result.resumo.totalCompletos))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cadastros Incompletos:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.result.resumo.totalIncompletos))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cadastros Não Aprovados:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.result.resumo.totalNaoAprovados))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cadastros Bloqueados:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.result.resumo.totalBloqueados))])])])])])])])]), _vm._v(" "), (!_vm.mostrarCadastros) ? _c('div', {
    staticClass: "text-center hidden-print"
  }, [_c('a', {
    staticClass: "btn btn-success center",
    on: {
      "click": function($event) {
        _vm.mostrarCadastros = true
      }
    }
  }, [_vm._v("Visualizar\n          Cadastros")])]) : _vm._e(), _vm._v(" "), (_vm.pages > 1 && _vm.mostrarCadastros) ? _c('div', {
    staticClass: "alert alert-warning text-center m-b hidden-print"
  }, [_vm._v("Este relatório é muito grande e teve que ser dividido em " + _vm._s(_vm.pages) + " páginas")]) : _vm._e(), _vm._v(" "), (_vm.pages > 1 && _vm.mostrarCadastros) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n          Página: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pages), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.mostrarCadastros) ? _c('div', {
    staticClass: "r-table relatorio-a-basico"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, _vm._l((_vm.filteredData), function(arrematante, key) {
    return _c('div', {
      staticClass: "pos-rlt b-b m-b-lg"
    }, [_c('table', {
      staticClass: "w-full table table-bordered m-b-none"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Situação")]), _vm._v(" "), _c('td', [_c('strong', {
      class: _vm.getStatusArrematante(arrematante.status).class
    }, [_vm._v(_vm._s(_vm.getStatusArrematante(arrematante.status).name))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arrematante")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(arrematante.pessoa.nome) + "\n                    (" + _vm._s(arrematante.apelido) + ") #A" + _vm._s(arrematante.id) + "-P" + _vm._s(arrematante.pessoa.id) + "\n\n                    ")])]), _vm._v(" "), (arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Tratamento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfTratamento))]), _vm._v(" "), _c('td', [_vm._v("Sexo")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfSexo === 1 ? 'M' : 'F'))])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(arrematante.pessoa.pfCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(arrematante.pessoa.pfCpf)))]) : _c('span', [_vm._v("SEM CPF")])]), _vm._v(" "), _c('td', [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfRg) + " " + _vm._s(arrematante.pessoa.pfRgOrgaoEmissor) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfDataNascimento ?
      _vm.moment(arrematante.pessoa.pfDataNascimento.date).format('L') : '-') + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfEstadoCivilString))])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 1 && (arrematante.pessoa.pfFiliacaoNomePai || arrematante.pessoa.pfFiliacaoNomeMae)) ? _c('tr', [_c('td', [_vm._v("Nome do Pai")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfFiliacaoNomePai))]), _vm._v(" "), _c('td', [_vm._v("Nome da Mãe")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pfFiliacaoNomeMae))])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Razão Social")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pjRazaoSocial ||
      arrematante.pessoa.nome) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pjNomeFantasia))])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pjCnpj))]), _vm._v(" "), _c('td', [_vm._v("Inscrição Estadual")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.pjInscricaoEstadual))])]) : _vm._e(), _vm._v(" "), (arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Responsável")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pjProprietarioNome))]), _vm._v(" "), _c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(arrematante.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(arrematante.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("IP Cadastro")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.ipCadastro))]), _vm._v(" "), _c('td', [_vm._v("Observação")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(arrematante.pessoa.observacao))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Endereço\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Cidade\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      UF\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((arrematante.pessoa.enderecos), function(endereco) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(endereco.logradouro) + ", " + _vm._s(endereco.numero) + " " + _vm._s(endereco.complemento) + ", " + _vm._s(endereco.bairro) + ", " + _vm._s(_vm._f("formataCep")(endereco.cep)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio && endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n                    ")])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Telefones\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "50%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Emails\n                    ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', _vm._l((arrematante.pessoa.telefones), function(telefone) {
      return _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("formataTelefone")(telefone.telefone)) + ",\n                  ")])
    }), 0), _vm._v(" "), _c('td', _vm._l((arrematante.pessoa.emails), function(email) {
      return _c('span', [_vm._v("\n                      " + _vm._s(email.email) + ",\n                  ")])
    }), 0)])])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('tbody', [_c('tr', [_c('td', [_c('router-link', {
      staticClass: "text-info",
      attrs: {
        "tag": "a",
        "to": {
          name: 'arrematante.visualizar',
          params: {
            id: arrematante.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                        https://intranet.consorciorioparkingcarioca.com/#/website/arrematantes/1\n                      ")])], 1)])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "border-bottom": "#000000 1px dashed",
        "margin-top": "20px"
      }
    })])
  }), 0)]) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b4986f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/RelatorioBasico.vue
// module id = 1949
// module chunks = 18